import {useEffect} from 'react';

export function useDebouncedEffect(
  fn: () => void,
  deps: unknown[],
  delay: number
) {
  useEffect(() => {
    const tout = window.setTimeout(fn, delay);
    return () => window.clearTimeout(tout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);
}
